import { useToast } from 'vue-toastification'

import {
  editDocument,
  createDocument,
  getDocument,
  getDocuments,
  deleteDocument,
  insertFile,
  getFileDownload
} from '@/services/documents/index'

const toast = useToast()

export default {
  namespaced: true,
  state: () => ({
    document: null,
    documents: [],
    loading: false,
    totalPages: null,
    totalContent: null,
    page: 1
  }),
  mutations: {
    setLoading(state, value) {
      state.loading = value
    },
    setDocument(state, document) {
      state.document = document
    },
    setDocuments(state, documents) {
      state.documents = documents
    },
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages
    },
    setTotalContent(state, totalContent) {
      state.totalContent = totalContent
    },
    setPage(state, page) {
      state.page = page
    }
  },
  actions: {
    async editDocument({ commit, dispatch, state }, docData) {
      commit('setLoading', true)
      if (!state.document?.id) {
        commit('setLoading', false)
        toast.warning('Documento não encontrado para editar', {
          timeout: 8000
        })
        return Promise.reject('Documento não encontrado')
      }
      return editDocument(docData, state.document.id)
        .then(() => {
          toast.success('Documento atualizado com sucesso', {
            timeout: 8000
          })
          return dispatch('fetchDocuments')
        })
        .catch(() => {
          toast.warning('Não foi possível editar o Documento', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    async fetchDocument({ commit }, documentId) {
      commit('setLoading', true)
      return getDocument(documentId)
        .then((response) => {
          commit('setDocument', response?.data)
        })
        .catch(() => {
          toast.warning('Erro ao buscar os dados do documento', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    async fetchDocuments({ commit, state }, params) {
      commit('setLoading', true)

      const { document, type, page, size } = params || {}

      const queryParams = {
        page: page ?? state.page ?? 0,
        documentId: document ?? null,
        size: size ?? 10,
        type: type ?? ''
      }

      return getDocuments({ params: queryParams })
        .then((response) => {
          commit('setDocuments', response.data.content)
          commit('setTotalPages', response.data.totalPages)
          commit('setTotalContent', response.data.totalElements)
        })
        .catch(() => {
          toast.warning('Erro ao buscar os documentos', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    updatePage({ commit }, page) {
      commit('setPage', page)
    },
    async createDocument({ commit, dispatch }, DocData) {
      commit('setLoading', true)
      return createDocument(DocData)
        .then((response) => {
          toast.success('Documento criado com sucesso')
          dispatch('fetchDocuments')
          return response
        })
        .catch(() => {
          toast.warning('Erro ao criar o documento', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    async deleteDocument({ commit, dispatch }, documentId) {
      commit('setLoading', true)
      return deleteDocument(documentId)
        .then(() => {
          toast.success('Documento deletado com sucesso')
          return dispatch('fetchDocuments')
        })
        .catch(() => {
          toast.warning('Erro ao deletar o documento', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    clearDocument({ commit }) {
      commit('setLoading', true)
      commit('setDocument', null)
      commit('setLoading', false)
    },
    // eslint-disable-next-line no-unused-vars
    async postFile({ commit }, data) {
      return insertFile(data.file, data.id)
        .then(() => {
          toast.success('Upload realizado com sucesso', {
            timeout: 8000
          })
        })
        .catch(() => {
          toast.warning('Não foi possível carregar o arquivo', {
            timeout: 8000
          })
        })
    },
    async fechVoucherDownload({ commit }, fileData) {
      commit('setLoading', true)
      try {
        const response = await getFileDownload(fileData.id)
        const mimeType =
          response.headers['content-type'] || 'application/octet-stream'
        const blob = new Blob([response.data], { type: mimeType })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileData.name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        toast.success('Download realizado com sucesso', { timeout: 8000 })
      } catch (error) {
        toast.warning('Não foi possível realizar o download do arquivo', {
          timeout: 8000
        })
      } finally {
        commit('setLoading', false)
      }
    }
  },

  getters: {
    getLoadingDocument: (state) => state.loading,
    getDocument: (state) => state.document,
    getDocuments: (state) => state.documents,
    getTotalPages: (state) => state.totalPages,
    getTotalContent: (state) => state.totalContent,
    getPage: (state) => state.page
  }
}
